import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonIncreaseProps: CustomButtonProps = {
  variant: 'solid',
  lineHeight: 'normal',
};

export const IncreaseAmountWrapper: CSSObject = {
  mb: 0.5,
  gap: '1.5',
};
